import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import styles from './Layout.module.css';

export default function Layout({ children }) {
  const navigate = useNavigate();
  const admin = JSON.parse(localStorage.getItem('admin') || '{}');
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      await api.post('/auth/logout', { refreshToken });
    } catch { /* ignore */ }
    localStorage.clear();
    navigate('/login');
  };

  const navLink = (to, icon, label) => (
    <NavLink
      to={to}
      className={({ isActive }) => isActive ? styles.active : ''}
      onClick={() => setOpen(false)}
    >
      {icon} {label}
    </NavLink>
  );

  return (
    <div className={styles.shell}>
      {/* Mobile top bar */}
      <div className={styles.topBar}>
        <button className={styles.hamburger} onClick={() => setOpen(o => !o)} aria-label="Menu">
          <span /><span /><span />
        </button>
        <div className={styles.topBarTitle}>⚙️ Admin Panel</div>
      </div>

      {/* Overlay */}
      {open && <div className={styles.overlay} onClick={() => setOpen(false)} />}

      <aside className={`${styles.sidebar} ${open ? styles.sidebarOpen : ''}`}>
        <div className={styles.logo}>
          <span>⚙️</span> Admin Panel
        </div>
        <nav className={styles.nav}>
          {navLink('/dashboard',   '🏠', 'Dashboard')}
          {navLink('/categories',  '📂', 'Categories')}
          {navLink('/subcategories','📋','Subcategories')}
          {navLink('/banners',     '🖼️', 'Banners')}
          {navLink('/packages',    '💎', 'Packages')}
          {navLink('/ads',         '📢', 'Ads')}
          {navLink('/reports',     '🚩', 'Reports')}
          {navLink('/interests',   '🤝', 'Interests')}
          {navLink('/users',       '👥', 'Users')}
          {navLink('/blocked',     '🚫', 'Blocked')}
          {navLink('/support',     '🎧', 'Support')}
          {navLink('/notifications','🔔','Notifications')}
          {navLink('/settings',    '⚙️', 'Settings')}
        </nav>
        <div className={styles.userBox}>
          <div className={styles.userName}>{admin.name || 'Admin'}</div>
          <div className={styles.userEmail}>{admin.email}</div>
          <button className={styles.logoutBtn} onClick={handleLogout}>Logout</button>
        </div>
      </aside>

      <main className={styles.main}>{children}</main>
    </div>
  );
}
